import { makeAutoObservable } from 'mobx';
import { AuthorizationModule } from '../../../core-logic/modules/authorization/AuthorizationModule';
import { LoginUIManager } from './managers/LoginUIManager';
import { IAppLoaderNavigationService } from '../../../../infrastructure/types/features/navigation/navigation-types';
import { RegisterUIManager } from './managers/RegisterUIManager';
import { RestorePasswordUIManager } from './managers/RestorePasswordUIManager';
import { InvitationUIManager } from './managers/InvitationUIManager';

class AuthorizationUIModule {
  loginUIManager: LoginUIManager;
  registerUIManager: RegisterUIManager;
  restorePasswordUIManager: RestorePasswordUIManager;
  invitationUIManager: InvitationUIManager;

  constructor(
    private authorization: AuthorizationModule,
    private navigationService: IAppLoaderNavigationService,
  ) {
    makeAutoObservable(this, {});

    this.loginUIManager = new LoginUIManager(this.authorization.loginManager);
    this.registerUIManager = new RegisterUIManager(this.authorization.registerManager);
    this.restorePasswordUIManager = new RestorePasswordUIManager(
      this.authorization.restorePasswordManager,
    );
    this.invitationUIManager = new InvitationUIManager(this.authorization.invitationManager);
  }

  get notificator() {
    return this.authorization.notificator;
  }

  get module() {
    return this.authorization;
  }

  get currentUser() {
    return this.authorization.currentUser;
  }

  trySessionLogin() {
    this.authorization.trySessionLogin();
  }

  tryLogin() {
    this.authorization.tryLogin();
  }

  tryTemporarySignIn(token: TemporaryAuthToken) {
    this.authorization.tryTemporarySignIn(token);
  }

  get temporarySignInErrorKey() {
    return this.authorization.temporarySignInErrorKey;
  }

  userIdToBuffer() {
    return this.navigationService.copyToBuffer(this.currentUser?.account_id.toString() || '');
  }

  logout() {
    this.authorization.logout();
  }
}

export { AuthorizationUIModule };
